module.exports = __webpack_public_path__ + "static/media/uima-allas.ca52bb78.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/uima-allas.jpg
 ** module id = 431
 ** module chunks = 0
 **/